// global-alert.component.ts
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ServiceService, AlertMessage } from '../../../core/services/service.service';

@Component({
    selector: 'app-global-alert',
    imports: [CommonModule, NgxSpinnerModule],
    templateUrl: './global-alert.component.html',
    styleUrls: ['./global-alert.component.css']
})
export class GlobalAlertComponent implements OnInit {
  alertMessage: AlertMessage | null = null;
  readonly spinnerName = 'globalAlertSpinner';

  constructor(private service: ServiceService) { }
  clearAlert(): void {
    this.service.clearAlert();
  }
  ngOnInit(): void {
    this.service.alert$.subscribe(message => {
      this.alertMessage = message;
      if (message) {
        setTimeout(() => this.service.clearAlert(), 3000);
      }
    });
  }
}
